/* eslint-disable import/no-anonymous-default-export */

import heHeader from './he';
import enHeader from './en';

export default {
    he: heHeader,
    en: enHeader,
};